import { AppState } from '../reducers';
import { defaultOptions } from '../reducers/data_table_reducer';

export const getSelectedOptions = (state: AppState, dataTableName: string) => state.dataTables[dataTableName] || defaultOptions;